import map from 'lodash/map'
import React, { memo, ReactNode } from 'react'

import { ElementButton } from '@Components/Elements/Button'
import { ElementChip } from '@Components/Elements/Chip'
import { ElementLabel } from '@Components/Elements/Label'
import { Elements as ElementsGraphQL } from '@Components/Elements/Types'
import { ElementTypography } from '@Components/Elements/Typography'
import { ElementTypographyRTE } from '@Components/Elements/TypographyRTE'

import styles from './Elements.module.scss'

export const Elements = memo(({
  dimWithText = false,
  disableLinks = false,
  elements,
}: {
  dimWithText?: boolean
  disableLinks?: boolean
  elements: ElementsGraphQL[]
}): ReactNode => {
  if (!elements || elements.length === 0) {
    return null
  }

  const shouldDim = dimWithText
    && elements.some(e => e.items?.some(item => item.__typename === 'ElementTypography' || item.__typename === 'ElementTypographyRTE'))

  return (
    <>
      {shouldDim && <div className={styles.dim} />}
      {map(elements, element => (
        <div
          key={element?.id}
          className={styles.elements}
          data-alignment={element?.alignment || 'start'}
          data-position={element?.position || 'left'}
          data-stacking-mode={element?.stackingMode || 'vertical'}
        >
          {map(element?.items, (item) => {
            switch (item.__typename) {
              case 'ElementButton': return <ElementButton key={item.id} disableLinks={disableLinks} {...item} />
              case 'ElementChip': return <ElementChip key={item.id} disableLinks={disableLinks} {...item} />
              case 'ElementLabel': return <ElementLabel key={item.id} disableLinks={disableLinks} {...item} />
              case 'ElementTypography': return <ElementTypography key={item.id} {...item} />
              case 'ElementTypographyRTE': return <ElementTypographyRTE key={item.id} {...item} />
              default: return null
            }
          })}
        </div>
      ))}
    </>
  )
})
